import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const ValidIncidentsPerAgeGroup
 = () => {

    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="AGEGROUPVICTIM" disaggregation = "sex"/>
        </>
    
  )
}

export default ValidIncidentsPerAgeGroup
